<template>
    <div>
        <section class="mbr-section mbr-parallax-background" id="content5-i" data-rv-view="17" style="background-image: url(assets/images/fazenda-732x543.jpg); padding-top: 120px; padding-bottom: 120px;">

            <div class="mbr-overlay" style="opacity: 0.7; background-color: rgb(0, 0, 0);">
            </div>

            <div class="container">
                <h3 class="mbr-section-title display-2">Código de ética</h3>
                <p>
                    EM CONSTRUÇÃO
                </p>
            </div>

        </section>
    </div>
</template>

<script>
export default {
  name: "Hero",
  props: {
    msg: String
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .hero {
        padding-top: 7rem;
        width: 100%;
        height: 500px;
        text-align: left;
    }

</style>
